import { useRouteError, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Stack } from '@mui/material';
import { WarningOutlined, HomeOutlined, FileTextOutlined } from '@ant-design/icons';

export default function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  console.error('Route error caught by ErrorBoundary:', error);

  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3
        }}
      >
        <WarningOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />

        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Halaman Tidak Ditemukan atau Terjadi Kesalahan
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {error?.statusText || error?.message || 'Maaf, halaman yang Anda tuju tidak dapat dimuat.'}
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="center">
          <Button variant="contained" startIcon={<HomeOutlined />} onClick={() => navigate('/')}>
            Dashboard
          </Button>
          <Button variant="outlined" startIcon={<FileTextOutlined />} onClick={() => navigate('/gudang/invoice')}>
            Ke Invoice
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
